<template>
	<div class="home">
		<div class="header">
			<div style="height: 90px;">
				<div style="width: 1400px;margin: 0 auto;">
					<img src="../../assets/logo.png" style="width: 140px;height: 70px;margin-top: 10px;" alt="">
				</div>
			</div>
			<div style="background-color: #51BA85;">
				<div class="top11 u-flex u-col-center u-row-between">
					<!-- <div class="logo" style="font-size: 0;">
						<img src="../../assets/logo.png" style="width: 100%;height: 100%;" alt="">
					</div> -->
					<div style="width: 300px;"></div>
					<router-link to="/">首页</router-link>
					<el-dropdown @command="changetab">
						<a href="javascript:;">
							产品与服务<i class="el-icon-arrow-down el-icon--right"></i>
						</a>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item v-for="(item,index) in datalist" :key="index" :command="item.id">{{item.name}}</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					<!-- <a href="javascript:;" @click="kaifang">鉴智大数据</a> -->
					<router-link to="/bigData">鉴智大数据</router-link>

					<router-link to="/about">关于我们</router-link>
					<router-link to="/Vip">会员中心</router-link>
					<div class="login" @click="tologin" v-if="!userdata.id">
						登录
					</div>
					<div class="u-flex u-col-center" @click="goUserInfo" v-else>
						<span style="font-size: 16px;margin-right: 8px;color: #fff;">{{userdata.nickname}}</span>
						<img style="width: 38px;height: 38px;border-radius: 100px;" v-if="userdata.headimg" :src="userdata.headimg" alt="">
						<img style="width: 38px;height: 38px;border-radius: 100px;" v-else src="../../assets/index.png" alt="">
					</div>
				</div>
			</div>
			<div class="down11" v-show="this.$route.meta.title!='鉴智大数据'&&this.$route.path!='/hospitalInfo'">{{this.$route.meta.title || '标题'}}</div>
			<div class="down11" v-show="this.$route.path=='/hospitalInfo'">
					<router-link to="/yiliao">超级医疗平台</router-link>
			>
			{{this.$route.meta.title || '标题'}}</div>
		</div>
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				datalist: [],
				userdata:{}
			}
		},
		created() {
			if (window.localStorage.token) {
				this.getuser()
			}
			this.getlist()
			
		},
		methods: {
			getlist() {
				this.$http({
					url: '/api/Product/product'
				}).then(res => {
					this.datalist = res.data
				})
			},
			getuser() {
				this.$http({
					url: '/api/Login/getUserInfo'
				}).then(res => {
					if(res.code == 1){
						this.userdata = res.data
					}else{
						this.$message.error("请登录")
					}
				}).catch(err => {
					window.localStorage.token = ''
					this.$router.replace({
						path:"/"
					})
					this.$message.error("请登录")
				})
			},
			tologin() {
				this.$router.push({
					path: "/login"
				})
			},
			changetab(e) {
				this.$router.push({
					path: "/Database",
					query:{
						active:`2-${e}`
					}
				})
			},
			kaifang() {
				this.$message.error("暂未开放")
			},
			goUserInfo() {
				this.$router.push({
					path: '/UserInfo'
				})
			}
		}
	}
</script>

<style lang="scss">
	.home {
		min-width: 1400px;

		.header {
			position: sticky;
			top: 0;
			left: 0;
			width: 100%;
			// height: 270px;
			background: #FFFFFF;
			z-index: 999;
			.down11 {
				line-height: 89px;
				width: 1400px;
				margin: 0 auto;
			}

			.top11 {
				width: 1400px;
				margin: 0 auto;
				height: 90px;
				border-bottom: 1px solid #F3F3F3;
				

				.login {
					width: 120px;
					line-height: 44px;
					border-radius: 22px;
					border: 1px solid #fff;
					text-align: center;
					font-size: 20px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #fff;
				}

				a {
					text-decoration: none;
					font-size: 16px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #fff;
				}

				.logo {
					width: 140px;
					height: 70px;
					background: #D8D8D8;
					text-align: center;

				}
			}
		}
	}
</style>
